import type { ReactNode } from 'react';
import { SiteFooter } from './SiteFooter';
import { PublicHeader } from './PublicHeader';

export function AuthLayout({ title, intro, children, footer }: { title: string; intro?: ReactNode; children?: ReactNode; footer?: ReactNode }) {
  return (
    <div className="auth">
      <PublicHeader showLogin={false} />
      <main className="auth__panel" id="contenu" tabIndex={-1}>
        <h1 className="auth__title">{title}</h1>
        {intro && <p className="auth__intro">{intro}</p>}
        {children}
        {footer && <p className="auth__footer">{footer}</p>}
      </main>
      <SiteFooter />
    </div>
  );
}
